export default __webpack_public_path__ + "static/media/Skirmisher's Krys.93450cdf.jpg";